import React, { useEffect, useState } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import useDashboardContext from 'contexts/dashboard.context';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import FormStepper from 'components/base/form-stepper';
import usePricingContext from 'contexts/pricing.context';
import EditMealPricingForm from './edit-meal-pricing-form';
import { apiService } from 'services/base.service';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { MealPricingFormType } from 'models/pricing.model';

export const DefaultMealPricingFormData: MealPricingFormType = {
  id: '',
  kitchen_price: '',
  itemIndex: 0
};

const EditMealsPricing = () => {
  const { setIsBackLink, setBackLinkTitle, setBackLink } = useDashboardContext();
  const [isCreatingVendors, setIsCreatingVendors] = useState(false);
  const {
    mealPricingFormData,
    step,
    setStep,
    setMealPricingFormData,
    selectedMealPricing,
    setSelectedMealPricing
  } = usePricingContext();

  const router = useNavigate();

  function isStepEmpty(data: any): boolean {
    for (const item of data) {
      for (const key in item) {
        if (typeof item[key] === 'string' && item[key] === '') {
          return true;
        }
      }
    }
    return false;
  }

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to vendors');
    setBackLink(MAIN_STORE_ROUTE_KEYS.VENDORS);
    return () => {
      setIsBackLink(false);
    };
  }, []);

  const editConversionItem = async () => {
    const data = {
      updates: [],
      new_items: [],
      mixes:
        mealPricingFormData?.map((_) => ({
          id: _?.id,
          name: _?.ingredient?.name,
          secton_name: _?.ingredient?.category,
          no_of_portions: Number(_?.no_of_portions),
          portion_type: _?.portion_type,
          kitchen_price: parseFloat(_.kitchen_price)
        })) || [],
      deletions: []
    };

    try {
      setIsCreatingVendors(true);
      const res = await apiService.post('ingredient-mix/cokitchen/bulk-update-mixes', { data });
      if (res) {
        router(MAIN_STORE_ROUTE_KEYS.EXCEL_MEAL_PRICING);
        setMealPricingFormData([DefaultMealPricingFormData]);
        toast(<ToastMessage message='Excel meal price updated successfully' type='success' />);
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err.response?.data?.message || 'Error updating excel meal'}
          type='error'
        />
      );
    } finally {
      setIsCreatingVendors(false);
    }
  };

  return (
    <div>
      <PageHeaderText
        title='Edit Meal Selling Price'
        description='Was there a change in price? Update here.'
      />
      <div className='max-w-[878px]'>
        <FormStepper
          disabled={isStepEmpty(mealPricingFormData)}
          title=''
          step={step}
          handleConfirmClick={() => editConversionItem()}
          setStep={setStep}
          onNextClick={() => {
            if (selectedMealPricing) return;
            setSelectedMealPricing({
              ...mealPricingFormData[0],
              itemIndex: 0
            });
          }}
          noOfSteps={1}
          hideSteps
          loading={isCreatingVendors}>
          <div>{<EditMealPricingForm />}</div>
        </FormStepper>
      </div>
    </div>
  );
};

export default EditMealsPricing;
